module.exports = __webpack_public_path__ + "img/ring_r_skip_0_0@3x.fcf2cc02.png";